// To avoid getting the wrong brand/region value due to DeepSearchResolver behavior in configuration manager
export const brandIdValPath = 'brand.id';
export const regionIdValPath = 'region.id';
export const regionAbbrevValPath = 'region.abbrev';
export const regionLiteralValPath = 'region.literal';
export const inStoreSignUpConfigName = 'ramp.inStoreSignUp';
export const accountSignInFormConfigName = 'ramp.signIn';
export const accountSignUpFormConfigName = 'ramp.signUp';
export const guestSignInFormConfigName = 'ramp.guestSignIn';
export const inStoreSignUpConsentConfigName = 'ramp.inStoreSocialConsent';
export const socialSignUpConsentConfigName = 'ramp.socialSignUpConsent';
export const rampCommonPath = 'ramp.common';
export const iamConfigName = 'ramp';

export const IAM_COMPONENT_SIGN_IN_SIGN_UP = 'RampSignInSignUp';
export const IAM_COMPONENT_IN_STORE = 'RampInStore';

export enum SocialProfileSearchParams {
    PROVIDER = 'provider',
    CONFIG_NODE_NAME = 'configNodeName',
    REDIRECT_URL = 'redirectUrl'
}

export enum AccountSignInSignUpSearchParams {
    REDIRECT_URL = 'redirectUrl',
    IS_GUEST = 'isGuest'
}

export enum IamType {
    IN_STORE = 'in-store-sign-up',
    SOCIAL_SIGN_UP = 'social-sign-up',
    SIGN_UP = 'sign-up',
    SIGN_IN = 'sign-in',
    GUEST_CHECKOUT = 'guest-checkout'
}

export type IamTypeKey = keyof typeof IamType;

export const accountLockedErrorMessage = 'elc_account_errors.account_locked_5_attempts';
export const ipLockedErrorMessage = 'elc_account_errors.network_limited';
export const accountMigratedErrorMessage = 'elc_account_errors.account_migrated_reset_password';
export const invalidSignInErrorMessage = 'elc_account_errors.invalid_sign_in';
export const signInErrorTransKey = 'elc_account_errors.sign_in_failure';
export const mobileNumberRegisteredErrorTransKey = 'mobileNumberRegistered';
export const posNoTransactionMessage = 'elc_account_errors.pos_no_transaction';
export const posGenericErrorMessage = 'elc_account_errors.pos_generic_error';
export const partialSignUpGenericErrorMessage = 'partialSignUpGenericErrorMessage';
export const completeSignUpGenericErrorMessage = 'completeSignUpGenericErrorMessage';
export const completeUserExistsErrorMessage = 'completeUserExistsErrorMessage';
export const signInToConnectSocial = 'signInToConnectSocial';
export const existingAccountFoundPleaseSignIn = 'existingAccountFoundPleaseSignIn';
export const existingAccountFoundWithMobilePleaseSignIn =
    'existingAccountFoundWithMobilePleaseSignIn';
export const genericErrorMessage = 'genericError';
export const genericClientErrorMessageKey = 'elc_errors.generic_400';
export const goBindAccountWithLine = 'elc_account.go_bind_account_with_line';
export const badCharErrorMessageKey = 'badCharValidationErrorMessage';
export const fieldContainsBadCharErrorKey = 'fieldContainsBadCharError';
export const genericSocialErrorMessage = 'socialSignInFailureMessage';
export const socialEmailMissingErrorMessage = 'emailMissingErrorMessage';
export const socialAlreadyConnectedErrorMessage = 'alreadyConnectedFailureMessage';
export const socialMobileNumberMissingErrorMessage = 'mobileNumberMissingErrorMessage';
export const socialMobileNumberInvalidErrorMessage = 'mobileNumberInvalidMessage';
export const socialMobileCountryCodeNotAllowedErrorMessage = 'mobileCountryCodeNotAllowedMessage';
export const socialBannerTextKey = 'socialAccountRegistration';
export const verifySocialEmailKey = 'verifySocialEmail';
export const alreadyRegisteredPleaseSignInMessage = 'alreadyRegisteredPleaseSignInMessage';

export const integerRegex = new RegExp('^[0-9]*$');
export const fieldNamePlaceholderRegex = /::\s*([a-z0-9_]+)\s*::/i;
export const translationPlaceholderRegex = /::([a-zA-Z0-9]+)::/g;
export const socialPlaceholderRegex = /::SOCIAL::/gi;
export const legacyRampUrlHashRegex = /#\/signup/i;

export const BARCODE_WIDTH_NARROW = 1.5;
export const BARCODE_WIDTH_WIDE = 2;

export enum SearchParam {
    REGION = 'region',
    BRAND = 'brand'
}

export const CSRF_TOKEN_COOKIE_NAME = 'csrftoken';
export const DATA_BEHAVIOUR = 'data-behaviour';
export const DATA_VULCAN_CONFIG = 'data-vulcan-config';
export enum UserIdentifier {
    USER_ID = 'userId',
    USER_LOYALTY_ID = 'loyaltyGlobalIdentifier',
    USER_LOYALTY_NUMBER = 'loyaltyMembershipNumber'
}

export enum CodeType {
    CODE128 = 'code128',
    QR_CODE = 'QR_CODE'
}

export enum AccountAccessPageTabId {
    SIGN_IN = 'sign-in',
    SIGN_UP = 'sign-up',
    GUEST_CHECKOUT = 'guest-checkout'
}

export const enum StorageKey {
    ACCOUNT_REDIRECT_URL = 'account_redirect_url',
    CONNECT_USER_ID = 'connect_user_id', // for backup user id to connect before redirect to the 3PP site.
    FORM_VALUES = 'form_values', // for backup form values to update user info before redirect to the 3PP site.
    SOCIAL_DISPLAY_NAME = 'social_display_name',
    SOCIAL_EVENT_SOURCE = 'social_sign_in_event_source',
    SOCIAL_STATE = 'social_state',
    SOCIAL_SIGN_UP_PROVIDER_SOURCE = 'social_sign_up_provider_source',
    CROSS_PLATFORM_AUTH = 'cross_platform_auth'
}

export const DEFAULT_DIGIT_OF_VERIFICATION_CODE = 6;
export const DEFAULT_FLASH_DURATION = 5000;
export const DEFAULT_DEBOUNCE_WAIT_TIME = 500;
export type OtpStatus =
    | typeof DEFAULT_STATUS
    | typeof SENT_STATUS
    | typeof ERROR_STATUS
    | typeof VERIFIED_STATUS;

export const DEFAULT_STATUS = 'default';
export const SENT_STATUS = 'sent';
export const ERROR_STATUS = 'error';
export const VERIFIED_STATUS = 'verified';
export const RESEND_OTP_AFTER = 'resend_otp_after';

export const DEFAULT_MOBILE_DISPLAY_FORMAT = 'INTERNATIONAL';
export const DEFAULT_MOBILE_VALUE_FORMAT = 'E.164';

const GENERIC_ERROR_MESSAGE = genericErrorMessage;
//Messages
export const OTP_SUCCESS_MESSAGE_TRANSLATION_KEY = 'otpCodeSent';
const OTP_ERROR_MESSAGE_INVALID_TRANSLATION_KEY = 'otpInvalidCode';
const OTP_ERROR_MESSAGE_FAILED_TRANSLATION_KEY = 'otpFailedToVerify';
export const OTP_ERROR_MESSAGE_TOO_MANY_ATTEMPTS_TRANSLATION_KEY = 'otpTooManyAttempts';
const OTP_ERROR_MESSAGE_EXPIRED_TRANSLATION_KEY = 'otpCodeExpired';
const OTP_ERROR_MESSAGE_TRANSLATION_KEY = 'otpServerErrorMessage';
const OTP_ERROR_MESSAGE_RESEND_BLOCKED_TRANSLATION_KEY = 'otpResendBlocked';
const OTP_SERVER_ERROR_MESSAGE_TRANSLATION_KEY = 'otpGenericErrorMessage';

export const OTP_SUCCESS_MESSAGE_EXISTED_USER = 'userExisted';

export const OTP_CHANGE_MOBILE_NUMBER = 'changeMobile';
export const OTP_CHANGE_EMAIL_ADDRESS = 'changeEmailTitle';
export const OTP_SWITCH_TO_EMAIL_VERIFICATION = 'otpSwitchToEmail';
export const OTP_SWITCH_TO_SMS_VERIFICATION = 'otpSwitchToSms';

export const RESET_PASSWORD_FAILURE = 'resetPasswordFailure';

export const otpMappings = {
    // No messages just redirect to next page.
    verified: '',
    // User status: existingUser.completed user. we don't want to expose our API to enumerate users
    // So the backend return this error code instead of user's detailed information
    errorcode001: OTP_SUCCESS_MESSAGE_EXISTED_USER,
    sent: OTP_SUCCESS_MESSAGE_TRANSLATION_KEY,
    invalid: OTP_ERROR_MESSAGE_INVALID_TRANSLATION_KEY,
    failed: OTP_ERROR_MESSAGE_FAILED_TRANSLATION_KEY,
    too_many_attempts: OTP_ERROR_MESSAGE_TOO_MANY_ATTEMPTS_TRANSLATION_KEY,
    expired: OTP_ERROR_MESSAGE_EXPIRED_TRANSLATION_KEY,
    error_message_key: OTP_ERROR_MESSAGE_TRANSLATION_KEY,
    server_error: OTP_SERVER_ERROR_MESSAGE_TRANSLATION_KEY,
    resend_blocked: OTP_ERROR_MESSAGE_RESEND_BLOCKED_TRANSLATION_KEY,
    reset_password_failure: RESET_PASSWORD_FAILURE,
    sign_in_failure: signInErrorTransKey
};

export const otpMessageTranslationKeys = [
    //Messages
    OTP_SUCCESS_MESSAGE_TRANSLATION_KEY,
    OTP_ERROR_MESSAGE_INVALID_TRANSLATION_KEY,
    OTP_ERROR_MESSAGE_FAILED_TRANSLATION_KEY,
    OTP_ERROR_MESSAGE_TOO_MANY_ATTEMPTS_TRANSLATION_KEY,
    OTP_ERROR_MESSAGE_EXPIRED_TRANSLATION_KEY,
    OTP_ERROR_MESSAGE_TRANSLATION_KEY,
    OTP_SUCCESS_MESSAGE_EXISTED_USER,
    GENERIC_ERROR_MESSAGE
] as const;

export const otpMiscellaneousTranslationKeys = [
    'enterVerificationCode',
    'otpInstruction',
    'otpNotReceiveCode',
    'otpResendCode',
    'otpCodeSent',
    'tryAgain',
    OTP_CHANGE_MOBILE_NUMBER,
    OTP_CHANGE_EMAIL_ADDRESS,
    OTP_SWITCH_TO_SMS_VERIFICATION,
    OTP_SWITCH_TO_EMAIL_VERIFICATION
];

export type OtpApiStatusKey = keyof typeof otpMappings;
export type OtpMessageTranslationKey = typeof otpMessageTranslationKeys[number];

export const OTP_TYPE_SMS = 'sms';
export const OTP_TYPE_EMAIL = 'email';
export const OTP_TYPE_EMAIL_SMS = 'emailsms';
export const OTP_TYPE_SMS_EMAIL = 'smsemail';
export type OtpType =
    | typeof OTP_TYPE_SMS
    | typeof OTP_TYPE_EMAIL
    | typeof OTP_TYPE_EMAIL_SMS
    | typeof OTP_TYPE_SMS_EMAIL;

export const PC_EMAIL_ADDRESS_VERIFIED_REQUEST_ID = 'pcEmailAddressVerifiedRequestId';
export const MOBILE_NUMBER_VERIFIED_REQUEST_ID = 'mobileNumberVerifiedRequestId';

export type UseCaseKey = 'signup' | 'social' | 'default';
export const FORM_FIELD_MOBILE_NUMBER = 'mobileNumber';
export const FORM_FIELD_PHONE2 = 'phone2';

export enum MessageType {
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warning'
}

export const appRootEl = {
    attrName: 'data-behaviour',
    viewName: IAM_COMPONENT_SIGN_IN_SIGN_UP,
    attrConfig: 'data-vulcan-config'
};

export const LOW_ENV_TOKEN =
    'VEVTVC0zMWE3NDQ0Ny0xNzUyLTQ3NjItYTA1YS1lNzM1NmQyOTdmNmI6dGVzdHNlY3JldGV2ZXJ5b25la25vd3M=';
export const PROD_TOKEN =
    'ZDc4MDg5OTktODBjMy00NGViLThjMzEtOGQ4NTRiZDY3YmE5OjZhZTk4ZTY2MzQxYjI0NjFiMmFjZTkxNGRhODE1YzkxODJhZDg3MjM4ZjQ1ODk4ZDFjZWIwMGU5M2E4NjQwOWU=';

export enum RiskLevels {
    LOW = 0, // low
    MEDIUM = 1, // medium
    HIGH = 2 // high
}

export enum OTP_FLOW {
    FRAUD = 'FRAUD',
    SIGN_IN_WITH_OTP = 'SIGN_IN_WITH_OTP',
    RESET_PASSWORD = 'RESET_PASSWORD',
    SIGN_UP = 'SIGN_UP'
}

export const UNKNOWN_ERROR = 'unknown' as const;
export const ROOT_NODE_CLASS = '.elc-iam';

export const INPUT_FIELD_HIGHLIGHTED_CLASS = 'elc-input-field-highlighted';

export const NOT_FOUND_ROUTE_PATTERN = '/not-found';

export const BAD_CHAR_VALIDATOR_NAME = 'badCharPattern';

export const QUERY_PARAM_KEY_STORE_ID = 'door';
export const QUERY_PARAM_KEY_TRANSACTION_ID = 'receipt';
export const QUERY_PARAM_KEY_SOCIAL_ACCESS_TOKEN = 'token';
export const QUERY_PARAM_KEY_REDIRECT_URL = 'redirect_url';
